import { useEffect, useState } from "react";

import { http } from "@/utils/http";
import { DocumentStatus } from "@/pages/Thread/types";

interface UseDocumentStatusReturn {
  documentStatus: DocumentStatus;
  isDocumentReady: boolean;
}

const POLLING_INTERVAL = 1000; 

export const useDocumentStatus = (
  documentVersionId: null | number
): UseDocumentStatusReturn => {
  const [documentStatus, setDocumentStatus] = useState<DocumentStatus>(null);

  useEffect(() => {
    if (!documentVersionId) {
      return;
    }

    let timeoutId: NodeJS.Timeout;

    const checkDocumentStatus = async () => {
      try {
        const response = await http.get<{ cruncher_status: string }>(
          `/api/plugin/documents/status/${documentVersionId}`
        );

        const status = response.data?.cruncher_status as DocumentStatus;
        setDocumentStatus(status);

        // Continue polling if document is still processing
        if (status !== "finished" && status !== "failed") {
          timeoutId = setTimeout(checkDocumentStatus, POLLING_INTERVAL);
        }
      } catch (error) {
        console.error("Error checking document status:", error);
        setDocumentStatus("failed");
      }
    };

    checkDocumentStatus();

    // Cleanup timeout on unmount
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [documentVersionId]);

  return {
    documentStatus,
    isDocumentReady: documentStatus === "finished",
  };
};
